import './index.styl'

const PARENT_VALUE = '-1'
const SPLIT_SYMBOL = '/'

export default {
  name: 'multi-picker',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: String,
      default: ''
    },
    splitSymbol: {
      type: String,
      default: SPLIT_SYMBOL
    },
    limitCount: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedList: [],
      currentList: []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.setData()

        document.body.appendChild(this.$el)
        
      }
      this.stopBodyScroll(!!val)
    }
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  computed: {
    hasSelected() {
      return this.currentList.some(d => d.selected)
    }
  },
  methods: {
    /**
     * 根据给定的数据找出叶子节点的 id
     * @param {Array} arr 数组
     * @return {String} id 叶子节点的 id
     */
    _findIdByNameArr(arr) {
      if (!arr.length) return null

      if (arr.length === 1) {
        return this.list.find(d => (d.name === arr[0] && d.parent === PARENT_VALUE)).id
      }

      if (arr.length === 2) {
        const firstLevel = this.list.find(d => d.name === arr[0] && d.parent === PARENT_VALUE)
        return this.list.find(d => (d.name === arr[1] && d.parent === firstLevel.id)).id
      }

      if (arr.length === 3) {
        const firstLevel = this.list.find(d => d.name === arr[0] && d.parent === PARENT_VALUE)
        const secondLevel = this.list.find(d => d.name === arr[1] && d.parent === firstLevel.id)
        return this.list.find(d => (d.name === arr[2] && d.parent === secondLevel.id)).id
      }
    },
    setData() {
      // 初始化数据
      this.currentList = []
      this.list.forEach(d => {
        d.limitCount && delete d.limitCount
      })

      // 设置后台的剩余限制人数
      Object.keys(this.limitCount).forEach(key => {
        const id = this._findIdByNameArr(key.split(this.splitSymbol))

        this.list.forEach(d => {
          if (d.id === id) {
            d.limitCount = this.limitCount[key]
          }
        })
      })

      // 设置当前列表及选中元素
      try {
        this.selectedList = this.value ? this.value.split(this.splitSymbol) : []
        if (this.selectedList.length) {
          const id = this._findIdByNameArr(this.selectedList)
          const parentId = this.list.find(d => d.id === id).parent
          this.currentList = this.list.filter(d => d.parent === parentId)
          this.currentList.forEach(d => {
            d.selected = d.id === id
          })
          this.selectedList.pop()
        } else {
          this.currentList = this.list.filter(d => d.parent === PARENT_VALUE)
        }
      } catch (error) {
        console.error(error)
        this.currentList = this.list.filter(d => d.parent === PARENT_VALUE)
        this.selectedList = []
      }
    },
    _getItemNameById(id) {
      return this.list.find(d => d.id === id).name || ''
    },
    _hasParentById(id) {
      return this.list.some(d => d.parent === id)
    },
    handleClickListItem(e) {
      const {id} = e.currentTarget.dataset
      if (!this._hasParentById(id)) {
        this.currentList = this.currentList.map(d => {
          d.selected = d.id === id ? !d.selected : false
          return d
        })
        return false
      }
      const name = this._getItemNameById(id)
      this.selectedList.push(name)
      this.currentList = this.list.filter(d => d.parent === id)
    },
    handleClickBack() {
      if (!this.currentList.length) return false
      this.currentList = this.currentList.map(d => {
        d.selected = false
        return d
      })
      const parent = this.list.find(d => d.id === this.currentList[0].parent).parent
      this.currentList = this.list.filter(d => d.parent === parent)
      this.selectedList.pop()
    },
    handleClickConfirm() {
      if (!this.hasSelected) return false
      const seletItem = this.currentList.find(d => d.selected)
      this.$emit('input', [...this.selectedList, seletItem.name].toString().replace(/,/g, SPLIT_SYMBOL))
      this.hide()
    },
    hide() {
      this.$emit('update:visible', false)
    },
    stopBodyScroll(isFixed) {
      let bodyEl = document.body
      let top = 0
      if (isFixed) {
        top = window.scrollY

        bodyEl.style.position = 'fixed'
        bodyEl.style.top = -top + 'px'
      } else {
        bodyEl.style.position = ''
        bodyEl.style.top = ''

        window.scrollTo(0, top) // 回到原先的top
      }
    }
  },
  render(h) {
    return (
      <div class="multi-picker-wrapper" v-show={this.visible}>
        <div class="picker-header">
          <span class="back" onClick={this.handleClickBack}>{this.selectedList.length ? '上一级' : ''}</span>
          {
            this.hasSelected ? (
              <span class="confirm" onClick={this.handleClickConfirm}>确定</span>
            ) : (
              <span class="confirm" onClick={this.hide}>取消</span>
            )
          }
        </div>
        {
          !!this.selectedList.length && <div class="picker-nav mt2r">
            {
              this.selectedList.map(d => (
                <span>
                  <span>{d}</span>
                  <span>&nbsp;/&nbsp;</span>
                </span>
              ))
            }
          </div>
        }
        {
          this.currentList.map((item, index) => {
            console.log('报名人数判断——-',item)
            let limit = item.limit || 0
            let limitCount = item.limitCount || 0
            if (limit && limitCount < 1) {
              return (
                <div
                  class={{
                    'line-item': true,
                    'disabled': true,
                    'mt2r': index === 0 && !this.selectedList.length
                  }}>
                  <span>{item.name}</span>
                  <span class="desc-right">报名人数已满</span>
                </div>
              )
            }
            return (
              <div
                class={{
                  'line-item': true,
                  'mt2r': index === 0 && !this.selectedList.length
                }}
                data-id={item.id}
                onClick={this.handleClickListItem}>
                <span>{item.name}</span>
                {
                  this._hasParentById(item.id) ? (
                    <i class="forward"></i>
                  ) : item.selected ? (
                    <i class="selected"></i>
                  ) : ('')
                }
              </div>
            )
          })
        }
      </div>
    )
  }
}